<template>
  <v-container fluid class="custom-container">

    <!-- Folders Header -->
    <v-layout
      justify-space-between
      align-center
      v-if="!isEmpty(groupedFolders)"
    >
      <sent-cards :folders="folders" />
    </v-layout>
    <v-layout
      v-if="!isEmpty(groupedFolders)"
      class="list-folders-actions"
      align-center
      justify-center
    >
      <span>Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount }}</span>
      <v-btn icon @click="pageNumber--" :disabled="pageNumber <= 1">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-btn icon @click="pageNumber++" :disabled="pageNumber >= pages">
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-layout>

    <!-- Folders -->
    <section class="folders" v-if="!isEmpty(groupedFolders)">
      <v-layout
        class="folder-list mb-3"
        v-for="(group,index) in groupedFolders"
        :key="index"
        column
      >
        <span
          class="subheading grey--text mt-3 mb-3 text-capitalize"
        >
          {{ index }}
        </span>

        <div class="elevation-1 group"  v-if="group.length > 0">
          <draggable :options="{ delay: dragDelay }">
            <v-layout
              class="item"
              v-for="folder in group"
              :key="folder.id"
              @click.stop="openFolder(folder.id)"
              justify-center
              align-center
              row
              wrap
              @dragstart="startDrag(folder.id)"
              @dragend="setDraggingItem(null)"
              @mousedown="startTimer(folder.id)"
              @mouseup="stopTimer"
              @mouseleave="stopTimer"
              :class="{ 'dragging': folder.id === draggingItemId }"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">

                  <v-flex class="pa-2" v-on="on">
                    <v-layout
                      class="folder-name"
                      align-center
                      row
                    >
                      <img
                        class="d-flex mx-3 folder-icon"
                        src="/static/images/folder/folder-closed-icon.svg"
                        alt="Ícone de Pasta"
                      />
                      <v-layout column>
                        <v-flex class="grey--text">
                          <span class="caption process-number">{{ folder.process_number }}</span>
                        </v-flex>
                        <v-flex class="type-name">
                          <span>{{ folder.folder_type.name }}</span>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-flex>

                  <v-flex class="pa-2" xs2 xl3 v-if="folder.entity" v-on="on">
                    <v-chip color="grey-lighten-2 entity-chip">
                      <v-avatar size="16" color="white">
                        <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                      </v-avatar>
                      <strong class="grey--text text--darken-2 text-truncate">
                        {{ folder.entity.name }}
                      </strong>
                    </v-chip>
                  </v-flex>

                  <v-flex class="pa-2" xs3 xl2>
                    <v-list class="user-card pa-0" v-if="folder.last_transaction.to_user">
                      <v-list-tile avatar>
                        <v-list-tile-avatar color="grey" size="24">
                          <img
                            v-if="folder.last_transaction.to_user.avatar.url"
                            :src="folder.last_transaction.to_user.avatar.url"
                            alt="Avatar"
                          />
                          <span class="caption" v-else>{{ acronym(folder.last_transaction.to_user.name) }}</span>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                          <v-list-tile-title class="body-1">
                            {{ shortName(folder.last_transaction.to_user.name) }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title class="caption">
                            {{ folder.last_transaction.to_user.role.name }}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>

                  <v-flex class="pa-2" xs2>
                    <v-icon
                      v-if="!isEmpty(folder.limit_date)"
                      size="22"
                      class="mr-2"
                    >
                      mdi-clock-fast
                    </v-icon>
                    <span class="caption">
                      {{ folder.limit_date || 'Prazo não definido' }}
                    </span>
                  </v-flex>

                  <v-flex xs2>
                    <v-layout justify-center>
                      <v-icon
                        v-if="folder.received_status === 'Recebido' &&
                        folder.last_transaction &&
                        folder.last_transaction.transaction_state.enum === 'refused'"
                        color="red"
                        size="22"
                        class="mr-2"
                      >
                        mdi-alert-circle-outline
                      </v-icon>
                      <v-icon
                        v-else-if="folder.received_status === 'Recebido'"
                        color="green"
                        size="22"
                        class="mr-2"
                      >
                        mdi-check-all
                      </v-icon>


                      <span
                        v-if="folder.received_status === 'Recebido' &&
                        folder.last_transaction &&
                        folder.last_transaction.transaction_state.enum === 'refused'"
                        class="caption red--text"
                      >
                        Recusado
                      </span>

                      <span
                        v-else-if="folder.received_status === 'Recebido'"
                        class="caption green--text"
                      >
                        Recebido
                      </span>
                      <span
                        v-else-if="folder.received_status === 'Não Recebido'"
                        class="caption grey--text"
                      >
                        Aguardando
                      </span>

                      <span v-else>Sem status</span>
                    </v-layout>
                  </v-flex>

                  <span class="folder-border"></span>

                </template>
                <span>
                  {{
                    formatDate(folder.last_transaction.updated_at) +' às ' +
                    hour(folder.last_transaction.updated_at)
                  }}
                </span>
              </v-tooltip>
            </v-layout>
          </draggable>
        </div>
      </v-layout>

    </section>

    <!-- Empty Content -->
    <v-container fill-height v-if="isEmpty(groupedFolders) && !loading.show">
      <v-layout column align-center justify-center>
        <v-icon class="mb-2" size="48" color="grey darken-2">mdi-send</v-icon>
        <span class="title font-weight-regular grey--text text--darken-2">
          Não há itens para exibir
        </span>
      </v-layout>
    </v-container>

  </v-container>
</template>


<script>
import { isEmpty, truncate } from "lodash";
import acronym from "@/utils/acronym";
import shortName from "@/utils/short-name";
import format from "date-fns/format";
import * as ptLocale from "date-fns/locale/pt";
import SentCards from "./SentCards";
import draggable from "vuedraggable";

export default {
  name: "sent",
  components: { SentCards, draggable },
  mounted() {
    // this.getFolders();
  },
  data() {
    return {
      firstRender: true,
      truncate,
      shortName,
      isEmpty,
      pageNumber: 1,
      rowsPerPage: 20,
      draggingItemId: null,
      timer: null,
      dragDelay: 1500
    };
  },
  methods: {
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;
    },
    acronym(string) {
      return acronym(string);
    },
    currentUserIsOwner(currentOwner) {
      return this.user.id === currentOwner.id;
    },
    getFolders() {
      this.$store.dispatch("toggleLoader", { show: true });
      this.$store
        .dispatch("getFoldersSent", {
          page: this.pageNumber,
          limit: this.rowsPerPage,
          searchText: this.searchText || ""
        })
        .finally(() => {
          this.$store.dispatch("toggleLoader", { show: false });
        });
      this.$store.dispatch("getFoldersCount");
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    formatDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    formatMonthYear(date) {
      return format(date, "MMMM [de] YYYY", { locale: ptLocale });
    },
    hour(date) {
      return format(date, "HH:mm", { locale: ptLocale });
    },
    truncateEntityName(entityName) {
      if (this.$vuetify.breakpoint.lgOnly) {
        return truncate(entityName, { length: 25 });
      }
      if (this.$vuetify.breakpoint.xlOnly) {
        return truncate(entityName, { length: 50 });
      }
      return truncate(entityName, { length: 15 });
    },
    orderDateToString(folder) {
      return this.formatMonthYear(folder.last_transaction.created_at);
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
    folders() {
      let folders = this.$store.getters.folders;
      if (folders.length === undefined) {
        return [];
      }

      folders = folders.map(item => {
        if (item.folder_section === "sent") {
          return {
            ...item,
            received_status: item.last_transaction.received_status,
            folder_section: "sent"
          };
        }
        return item;
      });
      folders = folders.filter(item => item.folder_section === "sent");
      return folders;
    },
    groupedFolders() {
      const group = {};
      this.folders.forEach(folder => {
        if (group[this.orderDateToString(folder)] == null) {
          group[this.orderDateToString(folder)] = [folder];
        } else {
          group[this.orderDateToString(folder)].push(folder);
        }
      });
      return group;
    },
    pages() {
      return this.$store.getters.foldersPagesCount;
    },
    foldersCount() {
      return this.$store.getters.activeTotalFolders;
    },
    pageStart() {
      return this.pageNumber * this.rowsPerPage - (this.rowsPerPage - 1);
    },
    pageStop() {
      return Math.min(
        this.pageStart + (this.rowsPerPage - 1),
        this.foldersCount
      );
    },
    searchText() {
      return this.$store.getters.searchText;
    }
  },
  watch: {
    pageNumber: {
      handler: "getFolders",
      immediate: true
    },
    searchText(val) {
      if (val === null || val === "" || val.length > 2) {
        this.getFolders();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.folder-list {
  &:last-child {
    margin-bottom: 75px;
  }
}

.custom-container {
  height: calc(100vh - 48px);
  position: relative;
  overflow: hidden;
}

.folders {
  overflow-y: auto;
  height: 100%;
  margin-top: 40px;
}

.list-folders-actions {
  position: absolute;
  z-index: 4;
  width: 97%;
  background: white;
  margin-top: 6px;
}

.dragging {
  background-color: #005ece;
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/sent/Sent.vue